import { productPaymentConfigService } from '@/services';
import { useQuery } from '@tanstack/react-query';

/** Raiz das chaves da tela de formas de pagamento — invalidar por ela atualiza lista e editor. */
export const PRODUCT_PAYMENT_SETTINGS_QUERY_KEY = [
  'product-payment-settings',
] as const;

/** Todos os produtos com o status da cobrança e do catálogo. */
export function useProductPaymentSettingsList() {
  return useQuery({
    queryKey: [...PRODUCT_PAYMENT_SETTINGS_QUERY_KEY, 'list'],
    queryFn: async () => {
      const response = await productPaymentConfigService.listPaymentSettings();
      if (!response.success || !response.data) {
        throw new Error(
          response.error ||
            'Não foi possível carregar as formas de pagamento dos produtos.'
        );
      }
      return response.data;
    },
  });
}
